module.exports = __webpack_public_path__ + "static/media/loc6_img11.83679237.jpg";